import { ChangeEvent } from "react";
import Input from "../Input/Input";
import Tooltip from "../Tooltip";
import "./ImageInput.css";

interface IImageInputProps {
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  imageTypes: string;
  imageHeight?: number;
  imageWidth?: number;
  imageSize: number;
  label: string;
  direction?: string;
  align?: string;
  id: string;
  isMultiple?: boolean;
  acceptImageType?: string;
  hasTooltip?: boolean;
  content?: string;
  required?: boolean;
}

export default function ImageInput({
  handleFileChange,
  imageHeight,
  imageWidth,
  imageTypes,
  imageSize,
  label,
  direction = "horizontal",
  align,
  id,
  isMultiple = false,
  acceptImageType = "image/*",
  hasTooltip,
  content = "",
  required = false,
}: IImageInputProps) {
  return (
    <div className="upload__image__container">
      {label && (
        <div className="label_with_tooltip">
          <label
            htmlFor={label}
            className={`${required ? "required" : ""} label upload__profile__label`}
          >
            {label}
          </label>
          {hasTooltip && (
            <Tooltip content={<p>{content}</p>}>
              <i className="icon-info-circle tooltip"></i>
            </Tooltip>
          )}
        </div>
      )}
      {/* <p className="upload__profile__label">{label}</p> */}
      <div
        className={`upload__input__container ${direction === "vertical" ? "vertical" : ""} ${align}`}
      >
        <Input
          type="file"
          id={id}
          hidden
          accept={acceptImageType}
          onChange={handleFileChange}
          multiple={isMultiple}
        />
        <div
          className="upload__input__box"
          onClick={() => document.getElementById(id)?.click()}
        >
          <i className="icon-add-square"></i>
          <span className="upload__input__placeholder">Upload</span>
        </div>
        <div className="upload__input__instructions">
          <p className="instructions__heading">
            File Types: <span className="instruction">{imageTypes}</span>
          </p>
          {imageWidth && imageHeight && (
            <p className="instructions__heading">
              Files Dimensions:{" "}
              <span className="instruction">
                {" "}
                {imageWidth}px X {imageHeight}px
              </span>
            </p>
          )}
          <p className="instructions__heading">
            File Size (Max): <span className="instruction">{imageSize}mb</span>
          </p>
        </div>
      </div>
    </div>
  );
}
